import script from "./StoriesSorting.vue?vue&type=script&lang=ts&setup=true"
export * from "./StoriesSorting.vue?vue&type=script&lang=ts&setup=true"

import "./StoriesSorting.vue?vue&type=style&index=0&id=09d3e669&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d3e669"]])

export default __exports__